// Partition the selected step ids into disconnected subgraphs. A subgraph root is
// any selected step with no incoming edge (exit/child/branch) from another selected
// step; each root is traversed to collect its reachable selected steps.
export const findDisconnectedSubgraphs = (stepIds, graph) => {
  const stepIdSet = new Set(stepIds);
  const hasIncomingConnection = new Set();
  const visited = new Set();
  const subgraphs = [];

  stepIds.forEach((stepId) => {
    const node = graph[stepId];
    if (node) {
      if (node.exit && stepIdSet.has(node.exit)) {
        hasIncomingConnection.add(node.exit);
      }
      if (node.child && stepIdSet.has(node.child)) {
        hasIncomingConnection.add(node.child);
      }
      if (node.branches) {
        node.branches.forEach((branchId) => {
          if (branchId && stepIdSet.has(branchId)) {
            hasIncomingConnection.add(branchId);
          }
        });
      }
    }
  });

  const roots = stepIds.filter((stepId) => !hasIncomingConnection.has(stepId));

  roots.forEach((rootId) => {
    if (!visited.has(rootId)) {
      const subgraph = [];
      const traverse = (stepId) => {
        if (visited.has(stepId) || !stepIdSet.has(stepId)) {
          return;
        }
        visited.add(stepId);
        subgraph.push(stepId);

        const node = graph[stepId];
        if (node) {
          if (node.exit) {
            traverse(node.exit);
          }
          if (node.child) {
            traverse(node.child);
          }
          if (node.branches) {
            node.branches.forEach((branchId) => {
              if (branchId) {
                traverse(branchId);
              }
            });
          }
        }
      };

      traverse(rootId);
      if (subgraph.length > 0) {
        subgraphs.push({ root: rootId, steps: subgraph });
      }
    }
  });

  return subgraphs;
};
